import {createClientCore} from '@simpleforyou/client-core';

export const clientCore = createClientCore();
